import { ShieldCheck } from 'lucide-react';

const SecurityPanelButton = ({ onClick, hasIssues = false }) => {
  return (
    <button
      onClick={onClick}
      data-testid="open-security-panel-button"
      className="relative p-2.5 backdrop-blur-xl bg-black/40 border border-neon-red/30 hover:border-neon-red hover:bg-neon-red/20 text-white transition-all duration-300"
      title="Panel de seguridad y conexiones"
    >
      <ShieldCheck className="w-4 h-4" />
      {hasIssues && (
        <span
          className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-yellow-400 rounded-full"
          data-testid="security-issues-indicator"
          style={{ boxShadow: '0 0 8px rgba(250, 204, 21, 0.9)' }}
        />
      )}
    </button>
  );
};

export default SecurityPanelButton;
